import http from '@/http'

const getHistoryCount = () => {
  return http.get('/aigc/api/business/user/popup/calcu-classwork')
}

export default {
  getHistoryCount
}
